import controller from "./analyticsVisualizations.controller";

/* analyticsVisualizations.component.js */

/**
 * @desc component for Analytics Visualizations
 * @example <analytics-visualizations></analytics-visualizations>
 */

const analyticsVisualizations = {
    controller: controller,
    controllerAs: 'avvm',
    templateUrl: '/App/Components/analyticsVisualizations/analyticsVisualizations.html'
};

export default analyticsVisualizations;